// extracted by css-extract-rspack-plugin
export default {"textContainer":"textContainer-6y4vm"};